import { render, staticRenderFns } from "./ServicesReservationTreatmentPlansTable.vue?vue&type=template&id=f06320d6&"
import script from "./ServicesReservationTreatmentPlansTable.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports